(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-einstant/assets/javascripts/init.js') >= 0) return;  svs.modules.push('/modules/tickets-einstant/assets/javascripts/init.js');
"use strict";


svs.eInstant.logger = new svs.core.log.Logger('module:tickets-einstant');
const _svs$app$ReactRouter = svs.app.ReactRouter,
  Route = _svs$app$ReactRouter.Route,
  Router = _svs$app$ReactRouter.PlayerRouter;
const _svs$eInstant$constan = svs.eInstant.constants.ROUTES,
  LOBBY = _svs$eInstant$constan.LOBBY,
  FAVORITES = _svs$eInstant$constan.FAVORITES,
  FAVORITES_INFO = _svs$eInstant$constan.FAVORITES_INFO,
  CATEGORY = _svs$eInstant$constan.CATEGORY,
  CATEGORY_INFO = _svs$eInstant$constan.CATEGORY_INFO,
  INFO = _svs$eInstant$constan.INFO,
  PLAY = _svs$eInstant$constan.PLAY,
  DEMO_PLAY = _svs$eInstant$constan.DEMO_PLAY,
  BET_DETAIL = _svs$eInstant$constan.BET_DETAIL,
  ALL_GAMES = _svs$eInstant$constan.ALL_GAMES,
  ALL_GAMES_INFO = _svs$eInstant$constan.ALL_GAMES_INFO;
const LoginRequiredRoute = svs.eInstant.shared.LoginRequiredRoute;
const EInstantRouter = _ref => {
  let _ref$baseName = _ref.baseName,
    baseName = _ref$baseName === void 0 ? svs.core.data.baseUrl : _ref$baseName;
  const RouterProvider = svs.eInstant.store.RouterProvider;
  const _svs$eInstant$lobby = svs.eInstant.lobby,
    Lobby = _svs$eInstant$lobby.Lobby,
    Category = _svs$eInstant$lobby.Category,
    Play = _svs$eInstant$lobby.Play,
    AllGames = _svs$eInstant$lobby.AllGames,
    Info = _svs$eInstant$lobby.Info,
    Favorites = _svs$eInstant$lobby.Favorites;
  const GameUnavailable = svs.eInstant.components.GameUnavailable;
  const Menu = svs.eInstant.shared.components.Menu;
  const cancelUrl = svs.core.data.baseUrl + LOBBY;
  const isMobile = svs.core.detect.formfactor.mobile();
  const InfoComponent = isMobile ? Info : Lobby;
  const hasError = Boolean(svs.eInstant.data.error);
  if (hasError) {
    const errorProps = svs.eInstant.data.error || {};
    return React.createElement(GameUnavailable, {
      action: errorProps.action,
      message: errorProps.message,
      subMessage: errorProps.subMessage,
      title: errorProps.title
    });
  }
  return React.createElement(Router, {
    basename: baseName
  }, React.createElement(RouterProvider, null, React.createElement(Menu, null), React.createElement(Route, {
    component: Lobby,
    exact: true,
    path: LOBBY
  }), React.createElement(LoginRequiredRoute, {
    cancelUrl: cancelUrl,
    component: Favorites,
    exact: true,
    path: FAVORITES
  }), React.createElement(LoginRequiredRoute, {
    cancelUrl: cancelUrl,
    component: Favorites,
    exact: true,
    path: FAVORITES_INFO
  }), React.createElement(Route, {
    component: InfoComponent,
    exact: true,
    path: INFO
  }), React.createElement(Route, {
    component: Category,
    exact: true,
    path: CATEGORY
  }), React.createElement(Route, {
    component: Category,
    exact: true,
    path: CATEGORY_INFO
  }), React.createElement(Route, {
    component: AllGames,
    exact: true,
    path: ALL_GAMES
  }), React.createElement(Route, {
    component: AllGames,
    exact: true,
    path: ALL_GAMES_INFO
  }), React.createElement(Route, {
    component: Play,
    path: DEMO_PLAY
  }), React.createElement(LoginRequiredRoute, {
    cancelUrl: cancelUrl,
    component: Play,
    exact: true,
    path: PLAY
  }), React.createElement(LoginRequiredRoute, {
    cancelUrl: cancelUrl,
    component: Play,
    exact: true,
    path: BET_DETAIL
  })));
};
setGlobal('svs.eInstant.router.EInstantRouter', EInstantRouter);
const target = document.getElementById('reactContainer');
target && ReactDOM.render(React.createElement(EInstantRouter, null), target);

 })(window);